module.exports = __webpack_public_path__ + "static/media/all-programs.a48640a2.ico";